import { StyleSheet } from 'react-native';

import { Stack } from 'expo-router';
import { StatusBar } from 'expo-status-bar';
import Toast, { BaseToast, ErrorToast } from 'react-native-toast-message';
import type { ToastConfig } from 'react-native-toast-message';
import type { ToastConfigParams } from 'react-native-toast-message';

import { colors } from '../theme';
import { inter500 } from '../utils/platform';

type ToastCustomProps = Record<string, never>;

const renderErrorToast = ({ onPress, text1, text2 }: ToastConfigParams<ToastCustomProps>) => (
  <ErrorToast
    contentContainerStyle={styles.toastContentContainer}
    onPress={onPress}
    style={styles.errorToast}
    text1={text1}
    text1Style={styles.toastText}
    text2={text2}
    text2Style={styles.toastText}
  />
);

const renderSuccessToast = ({ onPress, text1, text2 }: ToastConfigParams<ToastCustomProps>) => (
  <BaseToast
    contentContainerStyle={styles.toastContentContainer}
    onPress={onPress}
    style={styles.successToast}
    text1={text1}
    text1Style={styles.toastText}
    text2={text2}
    text2Style={styles.toastText}
  />
);

const toastConfig: ToastConfig = {
  error: renderErrorToast,
  success: renderSuccessToast,
};

export default function RootLayout() {
  return (
    <>
      <Stack
        screenOptions={{
          contentStyle: { backgroundColor: colors.background },
          headerShadowVisible: false,
          headerStyle: { backgroundColor: colors.background },
          headerTintColor: colors.text,
          headerTitleStyle: {
            fontFamily: inter500,
          },
        }}
      />
      <StatusBar style="light" />
      <Toast config={toastConfig} />
    </>
  );
}

const styles = StyleSheet.create({
  errorToast: {
    backgroundColor: colors.surface,
    borderLeftColor: '#ff6b6b',
  },
  successToast: {
    backgroundColor: colors.surface,
    borderLeftColor: colors.green,
  },
  toastContentContainer: {
    backgroundColor: colors.surface,
  },
  toastText: {
    color: colors.text,
    fontSize: 13,
    fontWeight: '500',
  },
});
